import React, { useEffect, useState } from "react";
import { listActiveScans } from "../lib/api";
import { CircleNotch, X } from "@phosphor-icons/react";
import { stopScan } from "../lib/api";

export const LiveJobsBar = () => {
  const [jobs, setJobs] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const data = await listActiveScans();
        if (!cancelled) setJobs(data || []);
      } catch (e) {}
    };
    tick();
    const iv = setInterval(tick, 2500);
    return () => {
      cancelled = true;
      clearInterval(iv);
    };
  }, []);

  if (!jobs.length) return null;

  return (
    <div className="bg-[#0A0A0A] text-[#D4FF00] border-b border-[#0A0A0A]" data-testid="live-jobs-bar">
      <div className="px-4 sm:px-6 py-2 flex items-center justify-between gap-3">
        <button
          data-testid="live-jobs-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase"
          style={{ fontFamily: "'IBM Plex Mono', monospace" }}
        >
          <CircleNotch size={14} weight="bold" className="animate-spin" />
          {jobs.length} SCAN{jobs.length > 1 ? "S" : ""} RUNNING · {jobs.reduce((s, j) => s + (j.found || 0), 0)} FOUND
        </button>
        <span
          className="text-[10px] tracking-[0.2em] uppercase text-[#D4FF00]/60 cursor-pointer"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "HIDE" : "SHOW"}
        </span>
      </div>
      {open && (
        <div className="border-t border-[#D4FF00]/20">
          {jobs.map((j) => (
            <div key={j.id} className="px-4 sm:px-6 py-3 border-b border-[#D4FF00]/10 last:border-b-0">
              <div className="flex items-center justify-between text-xs mb-1" style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
                <span className="tabular-nums">
                  {j.country_flag} {j.country_name} · {j.kind.toUpperCase()} · <span className="text-white">+{j.found || 0}</span>
                </span>
                <button
                  data-testid={`stop-scan-${j.id}`}
                  onClick={() => stopScan(j.id)}
                  className="text-[#D4FF00]/60 hover:text-[#D4FF00]"
                  title="Stop"
                >
                  <X size={14} weight="bold" />
                </button>
              </div>
              <div className="text-[10px] text-[#D4FF00]/70 max-h-24 overflow-y-auto" style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
                {(j.log || []).slice(-6).map((l, i) => (
                  <div key={i} className="tabular-nums whitespace-pre-wrap">
                    &gt; {l.msg}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
